'use strict';

function filterMediasVoile(g) {
  var filters = [];
  var currentPage = 1;
  var postType;

  function init() {
    postType = $('#main-content article').attr('data-post-type');

    initModaals();

    $('.filtre__input').click(function(e) {
      $('.btn--load-medias').show();
      var filterValueSelected = $(this).attr('id');
      currentPage = 1;
      if ($(this).is(':checked')) {
        filters.push(filterValueSelected);
      } else {
        filters = filters.filter(function(filter) {
          return filter !== filterValueSelected;
        });
      }
      load(true);
    });

    $('.btn--load-medias').click(function() {
      currentPage++;
      load(false);
    });
  }

  function load(clean) {
    $sectionToutesActus = $('.section-toutes-actus');
    $blocActusList = $('.bloc-medias-voile__list');

    $.ajax({
      url: loadMoreMediasVoile.ajaxurl,
      method: 'GET',
      data: {
        action: 'filterMediasVoile',
        postType: postType,
        page: currentPage,
        fieldTypeMedia: loadMoreMediasVoile.fieldTypeMedia,
        tag__and: filters
      },
      beforeSend: function(data) {
        $sectionToutesActus.addClass('is-loading ');
      },
      success: function(data) {
        data = JSON.parse(data);
        $sectionToutesActus.removeClass('is-loading ');

        // Update content
        var template = '';
        data.templates.forEach(function(item) {
          template = template.concat(item);
        });

        if (clean) {
          $blocActusList.html(template);
        } else {
          $blocActusList.append(template);
        }

        // Réinitialise les modals pour intégrer les éléments chargés dynamiquement
        initModaals();

        // Hide/Show loadMore button
        if ( $('.bloc-medias-voile__list').children().length >= data.totalItems ) {
          $('.btn--load-medias').hide();
        } else {
          $('.btn--load-medias').show();
        }
      },
      error: function(data) {
        console.log('Erreur…');
      }
    });
  }

  function initModaals() {
    // Médias voile (modale image)
    $('.js-modaal-medias-voile').modaal({
      type: 'image',
      background: '#ffffff',
      overlay_opacity: '.9',
      custom_class: 'modaal-wrapper--medias-voile',
      after_open: function() {
        $('.modaal-gallery-control').addClass('btn btn--icon btn--icon-only');

        // Pour chaque lien, on récupère le numéro (data-numero)
        // On récupère le gallery-item correspondant
        // Et on fait passer le data-modaal-accessible-title du lien au title du gallery-item
        $('.js-modaal-medias-voile').each(function() {
          $index = $(this).data('number');
          $title = $(this).data('modaal-accessible-title');
          $('.gallery-item-' + $index).attr('title', $title);
        });


        // Récupère la valeur du `data-modaal-accessible-title` du lien courant
        $titleModale = $(this)[0]['$elem'][0]['attributes']['data-modaal-accessible-title'].value;
        $('.modaal-gallery-item').prepend('<span class="modaal-gallery-title">' + $titleModale + '</span>');
      },
      before_image_change: function() {
        // On masque le titre juste avant de changer d'image pour que ce soit plus esthétique
        $('.modaal-gallery-title').html('');
      },
      after_image_change: function(currentItem) {
        var classList = $(currentItem)[0].classList;
        var itemId = -1;

        for (var index = 0; index < classList.length; index++) {
          if (classList[index].startsWith('gallery-item-')) {
            itemId = parseInt(classList[index].replace('gallery-item-', ''));
          }
        }

        if (itemId >= 0) {
          // On change le titre
          $titleModale = $('.js-modaal-medias-voile').eq(itemId).data('modaal-accessible-title');
          $('.modaal-gallery-title').html($titleModale);
        }
      }
    });

    // Médias voile (modale vidéo ou audio)
    $('.js-modaal-medias-voile-video').modaal({
      type: 'video',
      background: '#ffffff',
      overlay_opacity: '.9',
      custom_class: 'modaal-wrapper--medias-voile'
    });
  }

  init();
}
